import { useLocale } from "@/shared/i18n/useT";
import { cn } from "@/shared/lib/cn";
import { formatDateTime, formatRelative } from "@/shared/lib/format";

/** "3 hours ago", with the exact date and time on hover and for assistive technology. */
export function TimeAgo({ value, className }: { value: string; className?: string }) {
  const { locale } = useLocale();
  return (
    <time
      dateTime={value}
      title={formatDateTime(value, locale)}
      className={cn("shrink-0 whitespace-nowrap tabular-nums", className)}
    >
      {formatRelative(value, locale)}
    </time>
  );
}
